// extracted by mini-css-extract-plugin
export default {"pagination-bar":"pagination-bar_pagination-bar__N2JLB"};